module.exports = __webpack_public_path__ + "static/PrimitiveThree-54360ab558e533bc63fa99c912109e7f.png";